import { NpsToDn } from "../../../shared/constants/pipe-diameter-conversion.constants";
import { Utils } from "../../../shared/constants/utilities.constants";
import { IDiameterCheckboxDropdown } from "../interfaces/diameter-checkbox-dropdown.interface";

export const returnSelectedItems = (selectedItems: IDiameterCheckboxDropdown[]): IDiameterCheckboxDropdown[] => {
    selectedItems.map(x => x.isSelected = true);
    return Utils.clone(selectedItems.sort((a, b) => (a.index) - (b.index)));
}

export const getDiameterList = (): IDiameterCheckboxDropdown[] => {
    return [
        {
            index: NpsToDn._1_8.index,
            isSelected: true,
            config: NpsToDn._1_8
        },
        {
            index: NpsToDn._1_4.index,
            isSelected: true,
            config: NpsToDn._1_4
        },
        {
            index: NpsToDn._3_8.index,
            isSelected: true,
            config: NpsToDn._3_8
        },
        {
            index: NpsToDn._1_2.index,
            isSelected: true,
            config: NpsToDn._1_2
        },
        {
            index: NpsToDn._3_4.index,
            isSelected: true,
            config: NpsToDn._3_4
        },
        {
            index: NpsToDn._1.index,
            isSelected: true,
            config: NpsToDn._1
        },
        {
            index: NpsToDn._1_1_4.index,
            isSelected: true,
            config: NpsToDn._1_1_4
        },
        {
            index: NpsToDn._1_1_2.index,
            isSelected: true,
            config: NpsToDn._1_1_2
        },
        {
            index: NpsToDn._2.index,
            isSelected: true,
            config: NpsToDn._2
        },
        {
            index: NpsToDn._2_1_2.index,
            isSelected: true,
            config: NpsToDn._2_1_2
        },
        {
            index: NpsToDn._3.index,
            isSelected: true,
            config: NpsToDn._3
        },
        {
            index: NpsToDn._3_1_2.index,
            isSelected: true,
            config: NpsToDn._3_1_2
        },
        {
            index: NpsToDn._4.index,
            isSelected: true,
            config: NpsToDn._4
        },
        {
            index: NpsToDn._5.index,
            isSelected: true,
            config: NpsToDn._5
        },
        {
            index: NpsToDn._6.index,
            isSelected: true,
            config: NpsToDn._6
        },
        {
            index: NpsToDn._8.index,
            isSelected: true,
            config: NpsToDn._8
        },
        {
            index: NpsToDn._10.index,
            isSelected: true,
            config: NpsToDn._10
        },
        {
            index: NpsToDn._12.index,
            isSelected: true,
            config: NpsToDn._12
        },
        {
            index: NpsToDn._14.index,
            isSelected: true,
            config: NpsToDn._14
        },
        {
            index: NpsToDn._16.index,
            isSelected: true,
            config: NpsToDn._16
        },
        {
            index: NpsToDn._18.index,
            isSelected: true,
            config: NpsToDn._18
        },
        {
            index: NpsToDn._20.index,
            isSelected: true,
            config: NpsToDn._20
        },
        {
            index: NpsToDn._22.index,
            isSelected: true,
            config: NpsToDn._22
        },
        {
            index: NpsToDn._24.index,
            isSelected: true,
            config: NpsToDn._24
        },
    ]
}

export const getDeletedOrAddedItem = (data1: IDiameterCheckboxDropdown[], data2: IDiameterCheckboxDropdown[]): IDiameterCheckboxDropdown | null => {
    let deletedItem: IDiameterCheckboxDropdown | null = null;
    for (const item of data1) {
        if (!data2.some(x => x.index === item.index)) {
            deletedItem = item;
            break;
        } else {
            continue;
        }
    }
    return deletedItem;
}

export const getItemsAfterDelete = (selectedItems: IDiameterCheckboxDropdown[], deletedItem: IDiameterCheckboxDropdown): IDiameterCheckboxDropdown[] => {
    const deletedIndex: number = selectedItems.findIndex(x => x.index === deletedItem.index);
    if (selectedItems.length > 1 && deletedIndex !== 0 && deletedIndex !== selectedItems.length - 1) {
        for (let index = selectedItems.length - 1; index >= 0; index--) {
            if (index >= deletedIndex) {
                selectedItems.splice(index, 1);
            } else {
                break;
            }
        }
    } else {
        selectedItems.splice(deletedIndex, 1);
    }
    return returnSelectedItems(selectedItems);
}


export const getItemsAfterInsert = (items: IDiameterCheckboxDropdown[], selectedItems: IDiameterCheckboxDropdown[], addedItem: IDiameterCheckboxDropdown): IDiameterCheckboxDropdown[] => {
    if (selectedItems.length === 0) {
        selectedItems.push(addedItem);
        return returnSelectedItems(selectedItems);
    } else {
        const newSelectedItems: IDiameterCheckboxDropdown[] = [];
        const lastIndex: number = selectedItems.length - 1;
        const fromIndex: number = addedItem.index < selectedItems[0].index ? addedItem.index : selectedItems[0].index;
        const toIndex: number = addedItem.index > selectedItems[lastIndex].index ? addedItem.index : selectedItems[lastIndex].index;
        for (let index = fromIndex; index <= toIndex; index++) {
            newSelectedItems.push(items[index]);
        }
        return returnSelectedItems(newSelectedItems);
    }
}